export enum PrefetchType {
  topImage = "topImage",
  areaThumbnails = "areaThumbnails",
  tourThumbnails = "tourThumbnails",
  guideThumbnails = "guideThumbnails",
  tourLocalMaps = "tourLocalMaps",
}

export type PrefetchState = { [key: string]: boolean };
